import TagManager from "react-gtm-module";
import { ClimbingArea } from "../../types";
import { toggleFavorite } from "../../utils/favorites";
import { useFavorites } from "../../hooks/useFavorites";

/// Save / Saved toggle for an area, shown on the dark hero
export function FavoriteButton({ area }: { area: ClimbingArea }) {
    const saved = useFavorites().some((f) => f.areaId === area.areaId);

    const handleClick = () => {
        const nowSaved = toggleFavorite(area);
        TagManager.dataLayer({
            dataLayer: {
                event: nowSaved ? 'favorite_add' : 'favorite_remove',
                area_name: area.name,
            }
        });
    };

    return (
        <button
            type="button"
            className={"favorite-button" + (saved ? " favorite-button--saved" : "")}
            aria-pressed={saved}
            onClick={handleClick}
        >
            <svg width="18" height="18" viewBox="0 0 24 24" fill={saved ? "currentColor" : "none"} stroke="currentColor" strokeWidth="2" strokeLinejoin="round" aria-hidden="true" focusable="false">
                <path d="M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1-4.4-4.3 6.1-.9z" />
            </svg>
            {saved ? "Saved" : "Save"}
        </button>
    );
}
